import React from 'react';
import { articlePresentation } from '../../../utils/adverseMediaArticlePolicy';
import { articleConcernRating } from '../../../utils/adverseMediaConcernRating';
import { articleReviewReasons } from '../../../utils/adverseMediaReviewReasons';

const clean = value => String(value ?? '').trim();
const badge = (text, tone = 'Grey', extraClass = '') => <span className={`badge badgeStandard badgeKyc${tone} ${extraClass}`}>{text}</span>;

export default function AdverseMediaArticleRow({ row, result, selected, readOnly, onToggle, assessmentPending = false }) {
  const display = articlePresentation(row, result);
  const assessment = result?.ok === true ? result.assessment : null;
  const concernRating = articleConcernRating(assessment, display.concern);
  const reviewRequired = articleReviewReasons(assessment, display.concern).length > 0;
  let url = '', domain = '';
  try { const parsed = new URL(row.link); if (/^https?:$/.test(parsed.protocol)) { url = parsed.href; domain = parsed.hostname; } } catch {}
  const capitalize = value => value[0].toUpperCase() + value.slice(1);
  const tone = display.concern === 'high' ? 'Red' : display.concern === 'medium' ? 'Yellow' : 'Grey';
  return <tr className={url ? 'kycClickableRow' : ''} onClick={() => url && window.open(url, '_blank', 'noopener,noreferrer')}>
    <td style={{ padding: '8px', verticalAlign: 'top' }}>
      <div className="text-muted small relevanceLabel mb-1">AML Relevance:</div>
      <div className="relevanceBadgeWrap">
        {display.concern === 'review' && concernRating ? badge(`${capitalize(concernRating)} concern`,
          concernRating === 'high' ? 'Red' : concernRating === 'medium' ? 'Yellow' : 'Grey',
          `kycAdverseConcernBadge--${concernRating}`) : null}
        {display.concernLabel ? badge(display.concernLabel, tone, `kycAdverseConcernBadge--${display.concern}`) : null}
        {reviewRequired && display.concern !== 'review' ? badge('Review needed', 'Grey', 'kycAdverseConcernBadge--review') : null}
        {display.statuses.map(status => <React.Fragment key={status}>{badge(status)}</React.Fragment>)}
        {display.implicated ? badge('Subject implicated') : null}
        {display.nameStrength ? badge(`${capitalize(display.nameStrength)} name match`) : null}
      </div>
      <div className="text-muted small sourceLabel mt-3 mb-1">Source:</div>
      <div className="sourceBadgeWrap">
        {domain ? badge(domain.length > 20 ? `${domain.slice(0, 20)}…` : domain) : null}
        {badge(`Source: ${display.sourceQuality === 'unknown' ? 'Uncertain' : capitalize(display.sourceQuality)}`, display.sourceQuality === 'high' ? 'Green' : display.sourceQuality === 'medium' ? 'Yellow' : 'Grey')}
      </div>
    </td>
    <td className={`kycAdverseArticleCell kycAdverseArticleCell--${reviewRequired ? 'review' : display.concern}`} style={{ padding: '8px', verticalAlign: 'top' }}>
      <div className="kycAdverseArticleContent">
        <div className="fw-semibold">{clean(row.title)}</div>
        <div className="text-muted small">{clean(row.snippet)}</div>
        {assessment ? <div className="mt-2">
          {assessment.concernsSummary ? <div className="text-muted small">{clean(assessment.concernsSummary)}</div> : null}
          {assessment.textSummary?.filter(Boolean).length ? <ul className="small text-muted mt-1 mb-0 ps-3">
            {assessment.textSummary.filter(Boolean).slice(0, 5).map((line, index) => <li key={index}>{clean(line)}</li>)}
          </ul> : null}
          <div className="text-muted small mt-1">
            {assessment.accusedParties?.length ? <><span className="fw-semibold">Accused parties:</span> {assessment.accusedParties.join(', ')}</> : 'No accused parties detected.'}
          </div>
        </div> : <div className="text-muted small mt-2">{!result && assessmentPending ? 'Waiting for article assessment…' : 'Article assessment unavailable.'}</div>}
      </div>
    </td>
    <td style={{ padding: '8px', verticalAlign: 'top' }} className="text-end">
      {readOnly ? selected ? badge('Selected') : null : <button type="button"
        className={`btn btn-sm ${selected ? 'kycArticleSelected' : 'btn-outline-secondary'}`}
        aria-pressed={selected} onClick={event => { event.stopPropagation(); onToggle(String(row.id)); }}>
        {selected ? 'Selected' : 'Select article'}
      </button>}
    </td>
  </tr>;
}
